import React from "react";
import {
    Box, Flex, Text, Table, Thead, Tbody, Tr, Th, Td,
    Badge, useColorModeValue,
} from "@chakra-ui/react";
import Card from "components/card/Card";
import { notificationTypeLabel } from "lib/labels";

function CompletionBadge({ status }) {
    if (status === "paid")      return <Badge colorScheme="green"  borderRadius="full" px="8px" fontSize="11px">Pagata</Badge>;
    if (status === "submitted") return <Badge colorScheme="blue"   borderRadius="full" px="8px" fontSize="11px">Inviata</Badge>;
    return                             <Badge colorScheme="orange" borderRadius="full" px="8px" fontSize="11px">In attesa</Badge>;
}

function SendBadge({ status }) {
    return status === "sent"
        ? <Badge colorScheme="green"  variant="subtle" borderRadius="full" px="8px" fontSize="11px">Inviata</Badge>
        : <Badge colorScheme="red"    variant="subtle" borderRadius="full" px="8px" fontSize="11px">Fallita</Badge>;
}

export default function TodayNotifications({ data = [] }) {
    const textColor   = useColorModeValue("secondaryGray.900", "white");
    const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
    const rowBorderColor = useColorModeValue("gray.100", "whiteAlpha.100");
    const headerBorderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");
    const theadBg = useColorModeValue("#fbfbfb", "whiteAlpha.50");
    const mutedColor  = useColorModeValue("gray.500", "whiteAlpha.600");

    return (
        <Card direction="column" w="100%" h="100%" p="0" overflowX={{ sm: "scroll", lg: "hidden" }}>
            <Flex justify="space-between" align="center" pt="20px" pb="16px" px="24px" borderBottom="1px solid" borderColor={headerBorderColor}>
                <Text color="secondaryGray.900" fontSize="18px" fontWeight="700" lineHeight="100%">
                    Notifiche di Oggi
                </Text>
                <Text fontSize="13px" color={mutedColor}>{data.length} inviate</Text>
            </Flex>

            {data.length === 0 ? (
                <Text px="24px" py="20px" color={mutedColor} fontSize="14px">Nessuna notifica inviata oggi.</Text>
            ) : (
                <Table variant="simple" color="gray.500" mb="0">
                    <Thead>
                        <Tr bg={theadBg} borderTop="1px solid" borderColor={headerBorderColor}>
                            <Th ps="24px" pe="10px" py="14px" borderColor={borderColor} textTransform="none" fontSize="sm" fontWeight="600" color={textColor}>Ospite</Th>
                            <Th px="10px" py="14px" borderColor={borderColor} textTransform="none" fontSize="sm" fontWeight="600" color={textColor}>Tipo</Th>
                            <Th px="10px" py="14px" borderColor={borderColor} textTransform="none" fontSize="sm" fontWeight="600" color={textColor}>Esito</Th>
                            <Th px="10px" py="14px" borderColor={borderColor} textTransform="none" fontSize="sm" fontWeight="600" color={textColor}>Inviata il</Th>
                            <Th ps="10px" pe="24px" py="14px" borderColor={borderColor} textTransform="none" fontSize="sm" fontWeight="600" color={textColor}></Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {data.map((n, i) => (
                            <Tr key={i}>
                                <Td ps="24px" pe="10px" py="14px" borderColor={rowBorderColor} fontSize="13px" fontWeight="500" color={textColor} maxW="160px">
                                    <Text noOfLines={1}>{n.guest}</Text>
                                </Td>
                                <Td px="10px" py="14px" borderColor={rowBorderColor} fontSize="13px" color={mutedColor}>{notificationTypeLabel(n.type)}</Td>
                                <Td px="10px" py="14px" borderColor={rowBorderColor}>
                                    <SendBadge status={n.send_status} />
                                </Td>
                                <Td px="10px" py="14px" borderColor={rowBorderColor} fontSize="13px" color={mutedColor}>{n.sent_at}</Td>
                                <Td ps="10px" pe="24px" py="14px" borderColor={rowBorderColor}>
                                    <CompletionBadge status={n.completion_status} />
                                </Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            )}
        </Card>
    );
}
